import React from 'react';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
const useStyles = makeStyles(theme => ({
  navButtons: {
    display: 'flex',
    justifyContent: 'space-between'
  }
}));

const StepButtonsDesktop = ({ activeStep, onBack, onNext, advanceText }) => {
  const classes = useStyles({})
    ;
  return (
    <div className={classes.navButtons}>
      <Button disabled={activeStep === 1} onClick={onBack}>
        back
      </Button>

      <Button variant="contained" color="primary" onClick={onNext}>
        {advanceText}
      </Button>
    </div>
  );
};

export default StepButtonsDesktop;
